import { render, staticRenderFns } from "./FullPageModal.vue?vue&type=template&id=d4ffbe0c"
import script from "./FullPageModal.vue?vue&type=script&lang=ts"
export * from "./FullPageModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports